import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getCommissionProgressById } from '../../api/commissionProgressApi';
import EditSalesCommissionModal from './editSalesCommissionModal';

const PP = "'Poppins', sans-serif";

export default function EditCommissionPage() {
    const { commProgressId } = useParams();
    const navigate = useNavigate();
    const [commission, setCommission] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const res = await getCommissionProgressById(commProgressId);
            setCommission(res.data);
        } catch (err) {
            console.error('Failed to load commission:', err);
        } finally {
            setLoading(false);
        }
    }, [commProgressId]);

    useEffect(() => { fetchData(); }, [fetchData]);

    if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}><CircularProgress /></Box>;
    if (!commission) return <Box sx={{ p: 4, textAlign: 'center' }}><Typography>Commission record not found.</Typography></Box>;

    const sd = commission.salesDetailsForCommissionProgress;
    const cd = commission.commissionProgressDto;

    return (
        <Box sx={{ maxWidth: 700, mx: 'auto' }}>
            <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}
                sx={{ mb: 2, fontFamily: PP, textTransform: 'none', color: '#64748B', fontWeight: 500, fontSize: '0.85rem' }}>
                Back
            </Button>

            <Typography variant="h5" sx={{ fontWeight: 700, fontFamily: PP, color: '#0F172A', mb: 0.5 }}>
                {cd?.commPayType} — Sale #{cd?.salesId}
            </Typography>
            <Typography sx={{ fontSize: '0.82rem', color: '#64748B', fontFamily: PP, mb: 2 }}>
                {sd?.customerName} &middot; {cd?.paymentToName}
                {cd?.paymentStatus && (
                    <Chip label={cd.paymentStatus} size="small" sx={{
                        ml: 1, fontSize: '0.6rem', fontWeight: 600,
                        backgroundColor: cd.paymentStatus === 'Completed' ? '#D1FAE5' : '#FEF3C7',
                        color: cd.paymentStatus === 'Completed' ? '#065F46' : '#92400E',
                    }} />
                )}
            </Typography>

            <EditSalesCommissionModal
                show={true}
                onHide={() => {}}
                selectedCommission={commission}
                onSaved={() => { fetchData(); }}
                fullPage={true}
            />
        </Box>
    );
}
